import React, { useMemo, useState } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { required } from "redux-form-validators";
import { renderField, renderselect, renderTextField } from "../../../../Components/Forms/renders";
import PropTypes from "prop-types";
import SwitcButton from "../../../../Components/Forms/switch";
import TimeSelect from "../../../../Components/Forms/time";
import MultiSelectDagen from "../../../../Components/Forms/multiselect";

const SensorEditForm = ({ handleSubmit, activeTab, setActiveTab }) => {
  const requiredValidator = useMemo(() => required(), []);

  const getTabButtonStyle = (tabName) => ({
    border: 'none',
    borderRadius: '0.375rem',
    marginRight: '0.25rem',
    backgroundColor: activeTab === tabName ? '#5a67d8' : 'transparent',
    color: activeTab === tabName ? '#fff' : '#8b5cf6',
    fontSize: '0.875rem',
    fontWeight: '500',
    padding: '0.625rem 1.25rem',
    transition: 'all 0.2s ease-in-out',
    boxShadow: activeTab === tabName ? '0 2px 4px rgba(90, 103, 216, 0.3)' : 'none'
  });

  const handleTabHover = (e, tabName, isEnter) => {
    if (activeTab !== tabName) {
      e.target.style.backgroundColor = isEnter ? '#f8f7ff' : 'transparent';
      e.target.style.color = isEnter ? '#5a67d8' : '#8b5cf6';
    }
  };

  return (
    <div className="box box-default">
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          {/* SNEAT STYLE TABS NAVIGATIE */}
          <div className="nav-align-top mb-4">
            <ul className="nav nav-pills nav-fill" role="tablist">
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === 'algemeen' ? 'active' : ''}`}
                  onClick={() => setActiveTab('algemeen')}
                  type="button"
                  role="tab"
                  style={getTabButtonStyle('algemeen')}
                  onMouseEnter={(e) => handleTabHover(e, 'algemeen', true)}
                  onMouseLeave={(e) => handleTabHover(e, 'algemeen', false)}
                >
                  <i className="bx bx-info-circle me-2"></i>
                  Algemeen
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === 'stroom' ? 'active' : ''}`}
                  onClick={() => setActiveTab('stroom')}
                  type="button"
                  role="tab"
                  style={getTabButtonStyle('stroom')}
                  onMouseEnter={(e) => handleTabHover(e, 'stroom', true)}
                  onMouseLeave={(e) => handleTabHover(e, 'stroom', false)}
                >
                  <i className="bx bx-bolt me-2"></i>
                  Stroom & Tarieven
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === 'betalingen' ? 'active' : ''}`}
                  onClick={() => setActiveTab('betalingen')}
                  type="button"
                  role="tab"
                  style={getTabButtonStyle('betalingen')}
                  onMouseEnter={(e) => handleTabHover(e, 'betalingen', true)}
                  onMouseLeave={(e) => handleTabHover(e, 'betalingen', false)}
                >
                  <i className="bx bx-credit-card me-2"></i>
                  Betalingen
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === 'app' ? 'active' : ''}`}
                  onClick={() => setActiveTab('app')}
                  type="button"
                  role="tab"
                  style={getTabButtonStyle('app')}
                  onMouseEnter={(e) => handleTabHover(e, 'app', true)}
                  onMouseLeave={(e) => handleTabHover(e, 'app', false)}
                >
                  <i className="bx bx-mobile-alt me-2"></i>
                  App
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === 'kiosk' ? 'active' : ''}`}
                  onClick={() => setActiveTab('kiosk')}
                  type="button"
                  role="tab"
                  style={getTabButtonStyle('kiosk')}
                  onMouseEnter={(e) => handleTabHover(e, 'kiosk', true)}
                  onMouseLeave={(e) => handleTabHover(e, 'kiosk', false)}
                >
                  <i className="bx bx-desktop me-2"></i>
                  Kiosk
                </button>
              </li>
            </ul>
          </div>

          {/* TAB CONTENT */}
          <div className="tab-content" style={{ backgroundColor: '#fff', borderRadius: '0.5rem' }}>
            {/* ALGEMEEN TAB */}
            {activeTab === 'algemeen' && (
              <div className="tab-pane fade show active">
                <div className="row g-4">
                  <div className="col-md-8">
                    <div className="card border-0 shadow-sm">
                      <div className="card-header bg-transparent border-bottom-0 pb-0">
                        <h5 className="card-title mb-0" style={{ color: '#566a7f', fontSize: '1.125rem', fontWeight: '600' }}>
                          <i className="bx bx-info-circle me-2" style={{ color: '#696cff' }}></i>
                          Profiel Informatie
                        </h5>
                      </div>
                      <div className="card-body pt-3">
                        <Field name="naam" type="input" validate={[required()]} component={renderField} label="Naam Gasten profiel" />
                        <Field name="beschrijving" type="input" component={renderTextField} label="Beschrijving profiel (optioneel)" />
                        <Field name="isStandaard" type="input" component={SwitcButton} label="Dit is het standaard profiel" />
                        <Field 
                          name="standplaatsCategorie" 
                          component={renderselect} 
                          label="Gekoppelde Standplaats Categorie (optioneel)" 
                          options={{
                            '': 'Geen categorie gekoppeld',
                            // Hier zouden de categorien moeten komen
                          }}
                        />
                        <Field 
                          name="precedence" 
                          component={renderselect} 
                          label="Prioriteit bij conflicten" 
                          options={{
                            'gast': 'Gast instellingen hebben voorrang',
                            'categorie': 'Categorie instellingen hebben voorrang'
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card border-0 shadow-sm">
                      <div className="card-header bg-transparent border-bottom-0 pb-0">
                        <h5 className="card-title mb-0" style={{ color: '#566a7f', fontSize: '1.125rem', fontWeight: '600' }}>
                          <i className="bx bx-time me-2" style={{ color: '#696cff' }}></i>
                          Check-in & Check-out
                        </h5>
                      </div>
                      <div className="card-body pt-3">
                        <Field name="minaantaldagen" type="input" component={renderField} label="Minimaal aantal dagen" />
                        <Field name="inchecktijd" type="number" component={TimeSelect} label="Check-in tijd" />
                        <Field name="uitchecktijd" type="number" component={TimeSelect} label="Check-out tijd" />
                        <Field name="autouitcheck" type="input" component={SwitcButton} label="Automatische uitcheck" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* STROOM & TARIEVEN TAB */}
            {activeTab === 'stroom' && (
              <div className="tab-pane fade show active">
                <div className="row g-4">
                  <div className="col-md-6">
                    <div className="card border-0 shadow-sm">
                      <div className="card-header bg-transparent border-bottom-0 pb-0">
                        <h5 className="card-title mb-0" style={{ color: '#566a7f', fontSize: '1.125rem', fontWeight: '600' }}>
                          <i className="bx bx-euro me-2" style={{ color: '#28c76f' }}></i>
                          Tarieven
                        </h5>
                      </div>
                      <div className="card-body pt-3">
                        <Field name="prijs" type="number" component={renderField} label="Prijs per kWh (€)" />
                        <Field name="minimaalkwh" type="number" component={renderField} label="Minimaal aantal kWh per boeking" />
                        <Field name="kwkinclusief" type="number" component={renderField} label="Inclusief kWh per dag" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card border-0 shadow-sm">
                      <div className="card-header bg-transparent border-bottom-0 pb-0">
                        <h5 className="card-title mb-0" style={{ color: '#566a7f', fontSize: '1.125rem', fontWeight: '600' }}>
                          <i className="bx bx-bolt me-2" style={{ color: '#ff9f43' }}></i>
                          Stroom Instellingen
                        </h5>
                      </div>
                      <div className="card-body pt-3">
                        <Field name="instellenkwh" type="input" component={SwitcButton} label="kWh instelling verplicht" />
                        <Field name="instellenamp" type="input" component={SwitcButton} label="Ampères kunnen worden ingesteld" />
                        <Field name="afwijkingAmpere" type="number" component={renderField} label="Toegestane ampèrage afwijking" />
                        <Field name="schakelen.in" type="input" component={SwitcButton} label="Gasten mogen stroom inschakelen" />
                        <Field name="schakelen.uit" type="input" component={SwitcButton} label="Gasten mogen stroom uitschakelen" />
                        <Field name="sendalert" type="input" options={[50, 60, 70, 80, 90]} component={MultiSelectDagen} label="Meldingen bij verbruik (%)" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* BETALINGEN TAB */}
            {activeTab === 'betalingen' && (
              <div className="tab-pane fade show active">
                <div className="row g-4">
                  <div className="col-md-12">
                    <div className="card border-0 shadow-sm">
                      <div className="card-header bg-transparent border-bottom-0 pb-0">
                        <h5 className="card-title mb-0" style={{ color: '#566a7f', fontSize: '1.125rem', fontWeight: '600' }}>
                          <i className="bx bx-credit-card me-2" style={{ color: '#ff9f43' }}></i>
                          Algemene Betalingsinstellingen
                        </h5>
                      </div>
                      <div className="card-body pt-3">
                        <Field name="betalen" type="input" component={SwitcButton} label="Betaling voor stroom verplicht (legacy)" />
                        <Field name="oprekening" type="input" component={SwitcButton} label="Betaling op rekening (jaarplaatsen)" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* APP TAB */}
            {activeTab === 'app' && (
              <div className="tab-pane fade show active">
                <div className="row g-4">
                  <div className="col-md-6">
                    <div className="card border-0 shadow-sm">
                      <div className="card-header bg-transparent border-bottom-0 pb-0">
                        <h5 className="card-title mb-0" style={{ color: '#566a7f', fontSize: '1.125rem', fontWeight: '600' }}>
                          <i className="bx bx-mobile-alt me-2" style={{ color: '#696cff' }}></i>
                          App Functionaliteit
                        </h5>
                      </div>
                      <div className="card-body pt-3">
                        <Field name="app.vertrekdatumwijzigen" type="input" component={SwitcButton} label="Vertrekdatum wijzigen" />
                        <Field name="app.uitchecken" type="input" component={SwitcButton} label="Zelf uitchecken" />
                        <Field name="app.qr" type="input" component={SwitcButton} label="QR code scannen" />
                        <Field name="app.openRegistratie" type="input" component={SwitcButton} label="Open registratie mogelijk" />
                        <Field name="app.reserveringssysteem" type="input" component={SwitcButton} label="Reserveringssysteem toegang" />
                        <Field name="app.reserveringMaken" type="input" component={SwitcButton} label="Reservering maken" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card border-0 shadow-sm">
                      <div className="card-header bg-transparent border-bottom-0 pb-0">
                        <h5 className="card-title mb-0" style={{ color: '#566a7f', fontSize: '1.125rem', fontWeight: '600' }}>
                          <i className="bx bx-credit-card me-2" style={{ color: '#28c76f' }}></i>
                          App Betalingen
                        </h5>
                      </div>
                      <div className="card-body pt-3">
                        <Field name="app.betalen" type="input" component={SwitcButton} label="Betaling via app mogelijk" />
                        <Field 
                          name="app.betaalmethode" 
                          component={renderselect} 
                          label="App Betaalmethode" 
                          options={{
                            'mollie': 'Mollie',
                            'paynl': 'Pay.nl'
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* KIOSK TAB */}
            {activeTab === 'kiosk' && (
              <div className="tab-pane fade show active">
                <div className="row g-4">
                  <div className="col-md-6">
                    <div className="card border-0 shadow-sm">
                      <div className="card-header bg-transparent border-bottom-0 pb-0">
                        <h5 className="card-title mb-0" style={{ color: '#566a7f', fontSize: '1.125rem', fontWeight: '600' }}>
                          <i className="bx bx-desktop me-2" style={{ color: '#8b5cf6' }}></i>
                          Kiosk Functionaliteit
                        </h5>
                      </div>
                      <div className="card-body pt-3">
                        <Field name="kiosk.vertrekdatumwijzigen" type="input" component={SwitcButton} label="Vertrekdatum wijzigen" />
                        <Field name="kiosk.uitchecken" type="input" component={SwitcButton} label="Zelf uitchecken" />
                        <Field name="kiosk.qr" type="input" component={SwitcButton} label="QR code scannen" />
                        <Field name="kiosk.urlEnable" type="input" component={SwitcButton} label="URL Kiosk inschakelen" />
                        <Field name="kiosk.timeout" type="number" component={renderField} label="Timeout (seconden)" />
                        <Field name="kiosk.url" type="url" component={renderField} label="URL Kiosk" placeholder="https://kiosk.example.com" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card border-0 shadow-sm">
                      <div className="card-header bg-transparent border-bottom-0 pb-0">
                        <h5 className="card-title mb-0" style={{ color: '#566a7f', fontSize: '1.125rem', fontWeight: '600' }}>
                          <i className="bx bx-credit-card me-2" style={{ color: '#ea5455' }}></i>
                          Kiosk Betalingen
                        </h5>
                      </div>
                      <div className="card-body pt-3">
                        <Field name="kiosk.betalen" type="input" component={SwitcButton} label="Betaling via kiosk mogelijk" />
                        <Field 
                          name="kiosk.betaalmethode" 
                          component={renderselect} 
                          label="Kiosk Betaalmethode" 
                          options={{
                            'mollie': 'Mollie',
                            'paynl': 'Pay.nl'
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* SUBMIT KNOP */}
          <div className="pull-left submit mt-4">
            <input type="submit" className="btn btn-next btn-fill btn-success btn-wd btn-mg" name="next" value="Update" />
          </div>
        </div>
      </form>
    </div>
  );
};

SensorEditForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  activeTab: PropTypes.string.isRequired,
  setActiveTab: PropTypes.func.isRequired,
};

const ReduxFormSensorEdit = reduxForm({
  form: "gasteprofiel_edit", // a unique identifier for this form
})(SensorEditForm);

const mapStateToProps = (state) => ({
  initialValues: state.gastenverbruik.gastenprofiel, // pull initial values from account reducer
});

export default connect(mapStateToProps)(ReduxFormSensorEdit);
